import React from 'react'
import '../style/result.css'
import img1 from '../images/case-6.jpeg'
import img2 from '../images/case-1.jpeg'
import img3 from '../images/case-2.jpeg'
import img4 from '../images/case-4.jpeg'
import img5 from '../images/case-5.jpeg'
import img6 from '../images/case-7.jpeg'


const CaseSudyCard = () => {
    return (
        <>
            <div className='container' id='caseStdC'>
                <h2 style={{ textAlign: 'center', marginTop: '50px', marginBottom: "50px", color: 'rgb(13, 92, 126)' }}>CASE STUDY</h2>
                <div className='row' id='rM2'>
                    <div className='col-md-4' id='caseConta'>
                        <img id='caseSt' src={img1} style={{ borderRadius: '400px', boxShadow: "0px 1px 5px 5px lightgray", marginTop: '25px' }} alt="client" />
                        <h4 style={{ marginTop: "20px" }}>SAJIT SHANKAR</h4>
                        <h6 style={{ marginTop: '15px', marginBottom: "20px" }}>Industrial Water Treatment Chemicals</h6>
                    </div>
                    <div className='col-md-8' id='innerCase'>
                        <div className='row' id='rowCase' >
                            <div className='col' >
                                <span style={{ color: 'black', width: '50px' }}>
                                    <h4 id='afT' style={{ marginLeft: '10px' }}>BEFORE COACHING  😢</h4>
                                    <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                                        <li>12 years old business and not moving over Max  15 Crore.</li>
                                        <li>Profitability was low and had major cashflow challenges</li>
                                        <li>All operations owner driven, no time to think and improve the current process and not enough time spent on Sales reviews</li>
                                    </ul>
                                </span>
                            </div>
                            <div className='col' >
                                <span style={{ color: 'black', width: "100px" }}>
                                    <h4 id='afT' style={{ marginLeft: '10px' }}>AFTER COACHING  🤩</h4>
                                    <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                                        <li>More than 33% growth in a single year. Closing FY 22-23 at 20 crores🤑</li>
                                        <li>Inventory challenge resolved - proper system for managing inventory is set</li>
                                        <li>Sales team has been hired - Process set - working on automation - BO totally out of the sales made it independent of BO😍😍</li>
                                    </ul>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row' id='rM21'>
                    <div className='col-md-4' id='caseConta'>
                        <img id='caseSt' src={img2} style={{ borderRadius: '400px', boxShadow: "0px 1px 5px 5px lightgray", marginTop: '25px' }} alt="client" />
                        <h4 style={{ marginTop: "20px" }}>Mr. Paresh Modi</h4>
                        <h6 style={{ marginTop: '15px', marginBottom: "20px" }}>Softpal Technologies Pvt Ltd</h6>
                    </div>
                    <div className='col-md-8' id='innerCase'>
                        <div className='row' id='rowCase' >
                            <div className='col' >
                                <span style={{ color: 'white', width: '50px' }}>
                                    <h4 id='afT' style={{ marginLeft: '10px' }}>BEFORE COACHING 🙁</h4>
                                    <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                                        <li>With a team of 30, Paresh was stuck in a loop of operational chaos</li>
                                        <li>Absence of standard operating procedures, unclear scorecards, and a lack of effective delegation rendered the company stagnant</li>
                                        <li>Also there was major challenge in scaling the business,The drive was there, but the road was unclear.</li>
                                    </ul>
                                </span>
                            </div>
                            <div className='col' >
                                <span style={{ color: 'white', width: "100px" }}>
                                    <h4 id='afT' style={{ marginLeft: '10px' }}>AFTER COACHING 🤩</h4>
                                    <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                                        <li>In just one transforM2ative year, Paresh not only doubled his company's revenue but also inked the deal of a lifetime: selling 74% of Softpal for a staggering 74 Crore, at a valuation of 100 Crore</li>
                                        <li>Creation of comprehensive Standard Operating Procedures.</li>
                                        <li>Implementation of scorecards for individual and team perforM2ance.</li>
                                    </ul>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row' id='rM2'>
                    <div className='col-md-4' id='caseConta'>
                        <img id='caseSt' src={img3} style={{ borderRadius: '400px', boxShadow: "0px 1px 5px 5px lightgray", marginTop: '25px' }} alt="client" />
                        <h4 style={{ marginTop: "20px" }}>Mr. Yogesh Panchal</h4>
                        <h6 style={{ marginTop: '15px', marginBottom: "20px" }}>Panchal Industries</h6>
                    </div>
                    <div className='col-md-8' id='innerCase'>
                        <div className='row' id='rowCase' >
                            <div className='col' >
                                <span style={{ color: 'black', width: '50px' }}>
                                    <h4 id='afT' style={{ marginLeft: '10px' }}>BEFORE COACHING 🙁</h4>
                                    <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                                        <li>With 45 years in the business, Yogesh Panchal faced significant challenges, including the lack of the right manpower and time constraints, which limited his ability to focus on strategic aspects of the business 😖</li>
                                        <li>The turnover for the previous financial year was 4 crore in 2022-23, indicating steady growth but with untapped potential 😟</li>
                                    </ul>
                                </span>
                            </div>
                            <div className='col' >
                                <span style={{ color: 'black', width: "100px" }}>
                                    <h4 id='afT' style={{ marginLeft: '10px' }}>AFTER COACHING 🤩</h4>
                                    <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                                        <li>Achieved the previous year's turnover of 4 crore within the first quarter itself! A remarkable 300% growth in just three months, (June is yet to complete) setting the stage for extraordinary success!</li>
                                        <li>Proper digital marketing setup implemented, leading to increased brand visibility and consistent lead generation 📈💻   </li>
                                    </ul>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row' id='rM21'>
                    <div className='col-md-4' id='caseConta'>
                        <img id='caseSt' src={img4} style={{ borderRadius: '400px', boxShadow: "0px 1px 5px 5px lightgray", marginTop: '25px' }} alt="client" />
                        <h4 style={{ marginTop: "20px" }}>Mr. Sudhakar Ponnuru</h4>
                        <h6 style={{ marginTop: '15px', marginBottom: "20px" }}>Smartedge Consulting</h6>
                    </div>
                    <div className='col-md-8' id='innerCase'>
                        <div className='row' id='rowCase' >
                            <div className='col' >
                                <span style={{ color: 'white', width: '50px' }}>
                                    <h4 id='afT' style={{ marginLeft: '10px' }}>BEFORE COACHING 🙁</h4>
                                    <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                                        <li>Mr. Sudhakar Ponnuru's 15-year-old business faced stagnation with no clear growth strategy😖</li>
                                        <li>As a solopreneur, he struggled with -building a team</li>
                                        <li>Focusing on viable products, and managing cash flow 😣</li>
                                        <li>Lacked a defined sales process and predictable revenue funnel 📉</li>
                                    </ul>
                                </span>
                            </div>
                            <div className='col' >
                                <span style={{ color: 'white', width: "100px" }}>
                                    <h4 id='afT' style={{ marginLeft: '10px' }}>AFTER COACHING 🤩</h4>
                                    <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                                        <li>A staggering 50% growth in just one year! Revenue soared from 70 lakhs in FY 2021-22 to an incredible 1.06 crores in FY 2022-23!🔥</li>
                                        <li>Business revolutionized: from solopreneurship to a strong team of seven professionals, focusing on viable products and optimizing cash flow 🌐📈</li>
                                        <li>Mr. Sudhakar Ponnuru tackled his biggest challenge of building a team and successfully expanded his business operations 💼🎯</li>
                                    </ul>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row' id='rM2'>
                    <div className='col-md-4' id='caseConta'>
                        <img id='caseSt' src={img5} style={{ borderRadius: '400px', boxShadow: "0px 1px 5px 5px lightgray", marginTop: '25px' }} alt="client" />
                        <h4 style={{ marginTop: "20px" }}>Mr. Jonathan Gola</h4>
                        <h6 style={{ marginTop: '15px', marginBottom: "20px" }}>JR ONE LIFTS PVT LTD </h6>
                    </div>
                    <div className='col-md-8' id='innerCase'>
                        <div className='row' id='rowCase' >
                            <div className='col' >
                                <span style={{ color: 'black', width: '50px' }}>
                                    <h4 id='afT' style={{ marginLeft: '10px' }}>BEFORE COACHING 🙁</h4>
                                    <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                                        <li>Jonathan Gola faced substantial challenges with a turnover of 6 crores (around 50 lakhs per month), but he was wrestling with inconsistency in sales and lead generation 😖</li>
                                        <li>Cash flow was a significant challenge, and a small team only added to the burden, making it difficult to handle increasing demands 😟</li>
                                    </ul>
                                </span>
                            </div>
                            <div className='col' >
                                <span style={{ color: 'black', width: "100px" }}>
                                    <h4 id='afT' style={{ marginLeft: '10px' }}>AFTER COACHING 🤩</h4>
                                    <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                                        <li>Achievement: With the power of coaching, the turnover for the first quarter of 2023-24 reached an impressive 2.5 crores, an average of 80+ lakhs per month, a YOY growth of over 60%!🔥</li>
                                        <li>The sales team expanded from 4 to a well-equipped team of 10, enhancing capacity to growing demands, leading to increased productivity and efficiency 👥🚀</li>
                                    </ul>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row' id='rM21'>
                    <div className='col-md-4' id='caseConta'>
                        <img id='caseSt' src={img6} style={{ borderRadius: '400px', boxShadow: "0px 1px 5px 5px lightgray", marginTop: '25px' }} alt="client" />
                        <h4 style={{ marginTop: "20px" }}>Dr. Saptarshi Sankar Chakrabarti </h4>
                        <h6 style={{ marginTop: '15px', marginBottom: "20px" }}>Pegasus Design Solutions</h6>
                    </div>
                    <div className='col-md-8' id='innerCase'>
                        <div className='row' id='rowCase' >
                            <div className='col' >
                                <span style={{ color: 'white', width: '50px' }}>
                                    <h4 id='afT' style={{ marginLeft: '10px' }}>BEFORE COACHING 🌧️</h4>
                                    <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                                        <li>Dr. Saptarshi found himself mired in a quicksand of ambiguous ideas.</li>
                                        <li>A lack of initial capital, coupled with the fear of stepping away from the security of a steady paycheck, weighed heavily on his dreams. It seemed like the birth of his venture was but a distant star, beautiful yet unreachable.</li>
                                    </ul>
                                </span>
                            </div>
                            <div className='col' >
                                <span style={{ color: 'white', width: "100px" }}>
                                    <h4 id='afT' style={{ marginLeft: '10px' }}>AFTER COACHING 💡</h4>
                                    <ul style={{ marginTop: '25px', fontSize: "15px", marginLeft: '0px' }}>
                                        <li>Pegasus Design Solutions came into existence, an outsourced model that required no initial investment yet began generating a consistent revenue of 3 lakhs per month in just a few months!</li>
                                        <li>Mastery in content marketing led to enhanced brand visibility and credibility.</li>
                                        <li>Powerful lead-generating channels like BARK and Google Ads diversified his lead sources.</li>
                                    </ul>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='pageNo' style={{marginTop:'25px', textAlign:"center", marginLeft:'5px'}}>
                    <h4>Page No.</h4>
                </div>
                <div className='row' style={{ marginTop: '25px', marginBottom: '20px' }}>
                    <div className='col' style={{ textAlign: 'end' }}>
                        <a href='/CaseStudy'>
                            <h2 style={{ border: "1px solid gray", display: 'inline-block', paddingLeft: '6px', paddingRight: '6px', paddingT: '2px', paddingBottom: '2px' }}>1</h2>
                        </a>
                    </div>
                    <div className='col' style={{ textAlign: 'start' }}>
                        <a href='/CaseStudy-2'>
                            <h2 style={{ border: "1px solid gray", display: 'inline-block', paddingLeft: '6px', paddingRight: '6px', paddingT: '2px', paddingBottom: '2px' }}>2</h2>
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CaseSudyCard
